import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SalesValidationService } from './service/sales-validation.service';
import { SalesValidation, QuestionsAnswers, QuestionAnswer, SesionQuestion } from './model/sales-validation.interface';
import { SesionService } from 'src/app/core/service/sesion.service';
import { SelectOption } from 'src/app/shared/components/atoms/select/model/option.interface';
import { animate, style, transition, trigger } from '@angular/animations';
import { PotentialCustomer } from '../potential-customer/model/potential-customer';

@Component({
  selector: 'app-sales-validation',
  templateUrl: './sales-validation.component.html',
  styleUrls: ['./sales-validation.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [style({ opacity: 0 }), animate('150ms', style({ opacity: 1 }))]),
      transition(':leave', [animate('150ms', style({ opacity: 0 }))]),
    ]),
  ],
})
export class SalesValidationComponent implements OnInit {
  submitted: boolean;
  sesionData?: SalesValidation | null;
  questionsAnswers: QuestionAnswer[] = [];
  questions: QuestionAnswer[] = [];
  answers: QuestionsAnswers[] = [];
  questionAndAnswersForm: FormGroup;
  valueLastAnswers: string = '1';
  salesValidation: SalesValidation | null;
  idAnswersFinal: number = 0;
  @Output()
  onComplete = new EventEmitter<number>();

  @Output()
  onBack = new EventEmitter();

  minimumPurchase?: number;

  constructor(
    private fb: FormBuilder,
    private services: SalesValidationService,
    private sesion: SesionService,
  ) {
    this.questionAndAnswersForm = this.fb.group({
      weeklyPurchase: ['', Validators.requiredTrue],
    });
    this.submitted = false;
    this.salesValidation = this.sesion.getItem('sales_validation');

    this.setMinimumPurchase();
    this.getSesion();
    this.questionAndAnswersForm.valueChanges.subscribe((changes) => {
      for (const controlName in changes) {
        this.questionAndAnswersForm.controls[controlName].valueChanges.subscribe((data) => {
          this.selectedOption(data, controlName);
        });
      }
    });
  }

  back() {
    this.onBack.emit();
  }

  ngOnInit(): void {
    this.getQuestionsAnswers();
  }

  setMinimumPurchase() {
    const addresData: PotentialCustomer | null = this.sesion.getItem('potential_customer');
    const state = addresData?.location.state;
    if (state) {
      this.services.getMinimumPurchase(state).subscribe((result: any) => {
        if (result && result != 'FUERA DE COBERTURA') this.minimumPurchase = result;
        else this.questionAndAnswersForm.controls['weeklyPurchase'].disable();
      });
    }
  }

  onSubmit() {
    this.submitted = true;

    if (this.questionAndAnswersForm.valid && !this.questionAndAnswersForm.controls['weeklyPurchase'].disabled) {
      let salesValidation: SalesValidation = {
        questionAndAnswers: this.getFormControlsValue(),
        idAnswersFinal: this.idAnswersFinal,
      };
      if (salesValidation.idAnswersFinal != 0) {
        this.sesion.setItem('sales_validation', salesValidation);

        this.formComplete();
      }
    }
  }

  formComplete() {
    this.onComplete.emit(4);
  }

  getFormControlsValue() {
    let questions: SesionQuestion[] = [];
    let question: {
      formId: string;
      value: string;
    };
    let i = 0;
    if (this.questionAndAnswersForm) {
      for (const key in this.questionAndAnswersForm.controls) {
        question = {
          formId: key,
          value: this.questionAndAnswersForm.controls[key].value,
        };
        questions.push(question);
        i++;
      }
    }
    return questions;
  }

  getQuestionsAnswers() {
    this.services.getQuestionsAnswers().subscribe((result: QuestionAnswer[]) => {
      this.questionsAnswers = result;
      this.selectQuestionsAnswers(result);
    });
  }

  selectQuestionsAnswers(result: QuestionAnswer[], parentId?: number) {
    let answersQuestionFather: QuestionAnswer;
    this.submitted = false;
    if (!parentId) {
      answersQuestionFather = this.setFirtsFatherAnswersQuestion(result);
    } else {
      answersQuestionFather = this.setFatherAnswersQuestion(result, parentId);
    }
    if (!answersQuestionFather.isLeaf) {
      this.setChildAnswersQuestion(result, answersQuestionFather);
    } else {
      this.salesValidation = null;
    }
  }

  setChildAnswersQuestion(result: QuestionAnswer[], answersQuestionFather: QuestionAnswer) {
    let formControlName = 'questionId' + answersQuestionFather?.id;
    answersQuestionFather.formId = formControlName;
    this.questionAndAnswersForm.addControl(
      formControlName,
      new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
    );
    this.validateChangeAnswers(answersQuestionFather);
    this.questions.push(answersQuestionFather);
    let answersQuestionChild = result.filter((question) => question.parentId == answersQuestionFather?.id);
    if (answersQuestionChild) {
      this.setAnswers(answersQuestionChild);
    }
    if (this.salesValidation) {
      this.setSessionDataInForm(formControlName);
    }
  }

  setAnswers(answersQuestionChild: QuestionAnswer[]) {
    let selectAnswers: SelectOption[] = [];
    answersQuestionChild.forEach((data) => {
      let answers: SelectOption = {
        value: data.id,
        text: data.description,
      };
      selectAnswers.push(answers);
    });
    let answersDto: QuestionsAnswers = {
      answers: selectAnswers,
    };
    this.answers.push(answersDto);
  }

  setSessionDataInForm(name: string) {
    let sessionForm = this.salesValidation?.questionAndAnswers.find((question) => question.formId == name);
    if (sessionForm) this.questionAndAnswersForm.controls[sessionForm?.formId].setValue(sessionForm.value);
  }

  setFirtsFatherAnswersQuestion(result: QuestionAnswer[]): QuestionAnswer {
    let resultFirtsFather = result.find((question) => question.parentId == null);
    if (resultFirtsFather) {
      return resultFirtsFather;
    } else {
      resultFirtsFather = {
        id: 0,
        parentId: 0,
        description: '',
        order: 0,
        active: false,
        isLeaf: false,
      };
      return resultFirtsFather;
    }
  }

  setFatherAnswersQuestion(result: QuestionAnswer[], parentId: number): QuestionAnswer {
    let resultFather = result.find((question) => question.parentId == parentId);
    if (resultFather) {
      return resultFather;
    } else {
      resultFather = {
        id: 0,
        parentId: 0,
        description: '',
        order: 0,
        active: false,
        isLeaf: false,
      };
      return resultFather;
    }
  }

  selectedOption(data: any, controlName: string) {
    if (this.valueLastAnswers != data) {
      this.valueLastAnswers = data;
      if (typeof this.valueLastAnswers == 'string') {
        let result = this.questionsAnswers.find((dto) => dto.id == Number(this.valueLastAnswers));
        if (result) {
          if (!result?.isLeaf && result.parentId) {
            this.idAnswersFinal = 0;
            let resultParent = this.questionsAnswers.find((dto) => dto.id == Number(result?.parentId));
            if (resultParent) {
              this.validateChangeAnswers(resultParent);
            }
            this.selectQuestionsAnswers(this.questionsAnswers, Number(this.valueLastAnswers));
          } else {
            this.idAnswersFinal = result.id;
            this.salesValidation = null;
            result.formId = controlName;
            this.validateChangeAnswers(result);
          }
        }
      }
    }
  }

  getSesion() {
    this.sesionData = this.sesion.getItem('sales_validation');
  }

  validateChangeAnswers(fatherQuestion: QuestionAnswer) {
    let result = this.questions.find((question) => question.formId == fatherQuestion.formId);
    if (result) {
      let index = this.questions.findIndex((question) => question.id == result?.id);
      for (let i = index + 1; this.questions.length > i; i++) {
        let formNameControl = this.questions[i].formId;
        if (formNameControl) {
          this.questionAndAnswersForm.removeControl(formNameControl);
        }
      }
      this.questions.splice(index + 1);
      this.answers.splice(index + 1);
    }
  }

  validateQuestion() {
    return this.questionAndAnswersForm.valid ? false : true;
  }
}
